import { z } from 'zod';
const getParticipantsWithPastShiftsAnalyticsParamsSchema = z.object({
    missionId: z.string().uuid().optional(),
    participantId: z.string().uuid(),
    returnEmpty: z.boolean().optional(),
});
const getParticipantsWithPastShiftsAnalyticsResponseSchema = z.object({
    approvedHours: z.number(),
    pendingHours: z.number(),
    deniedHours: z.number(),
    shifts: z.number(),
});
export const getParticipantsWithPastShiftsAnalyticsFunctionDef = {
    name: 'getParticipantsWithPastShiftsAnalytics',
    requestSchema: getParticipantsWithPastShiftsAnalyticsParamsSchema,
    responseSchema: getParticipantsWithPastShiftsAnalyticsResponseSchema,
};
